import type { PageBlockDefinition } from '../definition-types'

export const unrankedListDefinition: PageBlockDefinition = {
  type: 'unranked-list',
  label: 'Unranked List',
  description: 'A plain headline list that supports static or feed content. No numbering or ranking.',
  rowCompatible: false,
  columnCompatible: true,
  category: 'editorial',
  minArticles: 2,
  maxArticles: 12,
  slots: [],
  defaultConfig: {
    sectionHeaderEnabled: false,
    sectionHeaderTitle: null,
    sectionHeaderStyle: 'rule-left',
    showSummary: false,
  },
  editorFields: [
    { key: 'sectionHeaderEnabled', label: 'Show Section Header', type: 'toggle' },
    { key: 'sectionHeaderTitle', label: 'Section Header Title', type: 'text' },
    {
      key: 'sectionHeaderStyle',
      label: 'Section Header Style',
      type: 'select',
      options: [
        { label: 'Rule Left', value: 'rule-left' },
        { label: 'All Caps', value: 'all-caps' },
        { label: 'Plain', value: 'plain' },
      ],
    },
    { key: 'showSummary', label: 'Show Summary', type: 'toggle' },
  ],
}
